import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import CheckIcon from '../Icons/CheckIcon';
import themeColors from '../../assets/styles/themeColors';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const MenuItemContainer = styled.div`
  padding: 0.75rem 0;
  display: flex;
  align-items: center;
  border-radius: 4px;
  background: ${(props) =>
    props.isActive
      ? themeColors.colorBackgroundSecondaryLight
      : themeColors.colorBackgroundPrimary};

  p {
    font-weight: ${(props) => (props.isActive ? 600 : 400)};
  }
`;

const MenuItemTitle = styled.p`
  padding: 0 0.625rem;
`;

const CheckIconContainer = styled.div`
  visibility: ${(props) => (props.checked ? 'visible' : 'hidden')};
  > svg {
    width: 0.75rem;
    object-fit: contain;
  }
`;

const MenuItem = ({ title, checked, isActive, children }) => {
  if (!title) {
    return null;
  }

  return (
    <Container>
      <MenuItemContainer isActive={isActive}>
        <CheckIconContainer checked={checked}>
          <CheckIcon />
        </CheckIconContainer>
        <MenuItemTitle>{title}</MenuItemTitle>
      </MenuItemContainer>
      {children}
    </Container>
  );
};

MenuItem.propTypes = {
  title: PropTypes.string,
  checked: PropTypes.bool,
  children: PropTypes.node,
  isActive: PropTypes.bool,
};

export default MenuItem;
